import { useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { useContext, useState, useEffect } from "react";
import AnimateLoader from "../AnimateLoader";
import { DataContext } from "../../context/dataContext";
import Navigator from "./Navigator";
import { BtnMenu, Menu } from "./_menu";
import { BtnPrev } from "./Next";
import Footer from "../admin/Footer";

export const SingleWork = ({ open, setOpen }) => {
    const { id } = useParams();

    const { getDataById } = useContext(DataContext);
    const [work, setWork] = useState(null);
    const [mainImage, setMainImage] = useState();

    useEffect(() => {
        getDataById(id)
            .then(data => {
                setWork(data);
                setMainImage(data.image)
            })
            .catch(() => {
                setWork(false)
            })

    }, [id]);

    if (work === null) {
        return <AnimateLoader />;
    }

    const changeImage = (image) => {
        console.log(image);
        setMainImage(image)

    }

    return (
        <>
            <BtnPrev to="/portafolio" />
            <BtnMenu open={open} setOpen={setOpen} />
            {open && <Menu open={open} setOpen={setOpen} />}
            <motion.div
                initial={{ y: "200%" }}
                animate={{ y: 0 }}

                className="w-100 h-100 d-flex flex-column p-md-5 mx-md-5"
                style={{
                    overflowY: "scroll",
                }}>
                <div className="container d-flex justify-content-center mt-4 pt-5 pt-md-0 h-100">
                    <div className="col-md-9 col-12">
                        <strong className="fs-1">{work.title}</strong>
                        <div className="window" style={{ height: 'auto' }}>
                            <Navigator />
                            <img src={mainImage} className="card-img-top mt-3" alt={work.title} />
                        </div>
                        <div className="w-100">
                            <ul className="galerias nav justify-content-center">
                                {work.galeria.map((item, i) => (
                                    <li
                                        key={i}
                                        onClick={() => changeImage(item)}
                                        className="nav-item">
                                        <img src={item} className="card-img-top mt-3" alt={work.title} />
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className="my-5">
                            <strong className="fs-2 mb-5">About this project</strong>
                            <p className="fs-4 fw-light">{work.description}</p>
                        </div>
                        <div className="mb-2">
                            <strong className="fs-2 mb-5">Technologies used</strong>
                            <p className="fs-4 ">Code thecnolies that I use in this proyect</p>
                            <ul className="fs-4 fw-light">
                                {work.tags.split(',').map(tag => (
                                    <motion.li
                                        key={tag}
                                        className="mb-2">
                                        {tag}
                                    </motion.li>
                                ))}
                            </ul>
                        </div>
                        <div className="mb-5 pb-5">
                            <strong className="fs-2 mb-5">Links</strong>
                            <p className="d-flex">
                                <span className="me-2 fs-4 fw-light">You can see this proyect on:  </span>
                                <a href={work.Link} target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                                    <i className="fas fa-external-link-alt"></i>
                                    <b className="fs-4 "> {work.Link} </b>
                                </a>
                            </p>

                        </div>
                    </div>

                </div>
             
            </motion.div>
            <Footer />

        </>
    )
}
export default SingleWork;
